import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import Blur from 'src/Components/shared/Blur'
import { If } from 'src/Components'
import RingLock from './RingLock'

import styles from './Lock.module.scss'

const propTypes = {
  blur: PropTypes.oneOf(['more', 'less']),
  enabled: PropTypes.bool,
  icon: PropTypes.node
}

const defaultProps = {
  blur: 'more',
  enabled: true,
  icon: <RingLock />
}

const Lock = ({ blur, className, enabled, icon, children, ...restProps }) => (
  <div className={classnames(className, styles.container)}>
    <If condition={children}>
      <Blur amount={blur} enabled={enabled}>
        {children}
      </Blur>
    </If>
    <If condition={enabled && icon}>
      <div className={styles.iconContainer}>{icon}</div>
    </If>
  </div>
)

Lock.propTypes = propTypes
Lock.defaultProps = defaultProps

export default Lock
